<template>
  <div class="over">
    <div class="heading">
      <h1>{{ $t("title.modalFreq") }}</h1>
    </div>
    <div class="content">
      <div class="device-select noselect" @click="showModal = !showModal">
        <p>{{ $t("message.groupSelection") }} {{ sensorsType }}:</p>
        <h2>{{ getSelectedGroupNumber }} - {{ getEUISByGroupNumber(getSelectedGroupNumber) }}</h2>
        <i v-bind:class="[showModal ? 'up' : 'down']"></i>
      </div>
      <ModalGroupSelect
        v-if="showModal"
        :sensorTypes="sensorsType"
        :groups="this.orderFDDGroups(getGroups)"
        :selectedGroupNumber="this.getSelectedGroupNumber"
        @selected="selectGroupNumber"
        id="device1"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalGroupSelect from "../../ui/ModalGroupSelect.vue";
export default {
  name: "groupSelect",
  components: {
    ModalGroupSelect,
  },
  data() {
    return {
      showModal: false,
    };
  },
  props: {
    sensorsType: String,
  },
  computed: {
    ...mapGetters({
      getSelectedGroupNumber: "FDD/getSelectedGroupNumber",
      getSensors: "structure/getSensors",
    }),
    getCurrentSensorsByType() {
      return this.getSensors.filter((i) => i.type === this.sensorsType);
    },
    getGroups() {
      // Ritorna un array di {group: 1, euis:[EUI1, EUI2...]}
      let uniqueGroups = [];
      this.getCurrentSensorsByType
        .filter((s) => s.groups)
        .map((sensor) => {
          sensor.groups.map((groupNumber) => {
            if (!uniqueGroups.some((i) => i.group === groupNumber)) {
              uniqueGroups.push({
                group: groupNumber,
                euis: [sensor.eui.substr(sensor.eui.length - 4)],
              });
            } else {
              uniqueGroups.find((i) => i.group === groupNumber).euis.push(sensor.eui.substr(sensor.eui.length - 4));
            }
          });
        });
      return uniqueGroups;
    },
  },
  methods: {
    ...mapActions({
      setSelectedGroupNumber: "FDD/setSelectedGroupNumber",
    }),
    orderFDDGroups(groups) {
      return groups.sort(function (a, b) {
        return a.group - b.group;
      });
    },
    selectGroupNumber(groupNumber) {
      this.setSelectedGroupNumber(groupNumber);
      this.showModal = false;
    },
    getEUISByGroupNumber(groupNumber) {
      let group = this.getGroups.find((gr) => gr.group === groupNumber);
      return group ? group.euis : null;
    },
  },
  async mounted() {
    let initalGroup = this.orderFDDGroups(this.getGroups);
    await this.selectGroupNumber(initalGroup[0].group);
  },
  watch: {
    // Quanto cambia il tipo di sensore aggiorno il gruppo selezionato
    sensorsType: {
      handler: async function () {
        let initalGroup = this.orderFDDGroups(this.getGroups);
        if (initalGroup[0]) {
          await this.selectGroupNumber(initalGroup[0].group);
        } else {
          await this.selectGroupNumber(null);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
/* Main Wrapper */
.over {
  min-width: 1000px;
  width: 92%;
  display: grid;
  grid-template-columns: 5fr 5fr;
  grid-template-rows: auto;
  margin-left: 4%;
  margin-right: 4%;
  margin-top: 20px;
  height: fit-content;
  border: solid 2px white;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  padding: 0 5%;
  box-sizing: border-box;
}

/* Wrapper Evento */
.heading {
  text-align: center;
  display: flex;
  justify-content: center;
  color: white;
  width: 100%;
  height: fit-content;
  grid-row: 1;
  grid-column: 1/3;
  position: relative;
  border-bottom: solid 2px rgb(150, 153, 162);
}
h1 {
  font-size: 1.2em;
  padding: 8px 0;
}
.content {
  margin: 10px 0;
  width: 100%;
  height: fit-content;
  grid-row: 2;
  position: relative;
  display: flex;
  justify-content: baseline;
}
.device-select {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.device-select h2 {
  margin-left: 5px;
}
/* Freccia */
i {
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 5px;
  position: relative;
  margin-bottom: auto;
  margin-top: auto;
  margin-left: 10px;
  bottom: 2px;
  transition: transform 0.3s cubic-bezier(0.42, 0, 0.1, 0.96);
}
.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

#device1 {
  position: absolute;
  top: 50px;
  left: 280px;
}
</style>